export const blockIconsHardwarePhoneiPhone = (
	<span className='material-symbols-outlined'>phone_iphone</span>
);
